import { render, staticRenderFns } from "./KnPersonalInfo.vue?vue&type=template&id=dcae8452&"
import script from "./KnPersonalInfo.vue?vue&type=script&lang=js&"
export * from "./KnPersonalInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports